import "./index.css";

function BoxTitle({ title }) {
  return (
    <div className="BoxTitle">
      <div>{title}</div>
    </div>
  );
}

export default BoxTitle;
